mutation CreateWidget($input: CreateWidgetInput!) {
  createWidget(input: $input) {
    id
    title
    buttonUrl
    buttonText
    buttonColor
    buttonTextColor
    hits
    clicks
    ctr
    createdAt
  }
}
